export default {
  components: {},

  mounted() {}
};
